import { http } from '../../../utils';
const controller = 'service-desk/objects';
export const getObjs = async (page, pageSize, orderBy, searchCondition, objectGroupId, objectTypeId, priority, ownerShipType, status) => {
    return await http.get(controller, {
        params: {
            searchCondition,
            objectGroupId,
            objectTypeId,
            status,
            priority,
            ownerShipType,
            page,
            pageSize,
            orderBy
        }
    });
};
export const getObj = async (id) => {
    return http.get(`${controller}/${id}`);
};
export const addObj = async (Obj) => {
    return http.post(controller, Obj);
};
export const updateObj = async (id, Obj) => {
    return await http.put(`${controller}/${id}`, Obj);
};
export const deleteObj = async (id) => {
    return await http.delete(`${controller}/${id}`);
};
export const getObjsAll = async (objFilterParams) => {
    return await http.get(`${controller}/get-all`, {
        params: objFilterParams
    });
};
